var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52232 17C3.09691 17 2.73684 16.86 2.44211 16.58C2.14737 16.3 2 15.9579 2 15.5538V12.4H7.89474V13.8H12.1053V12.4H18V15.5538C18 15.9579 17.8526 16.3 17.5579 16.58C17.2632 16.86 16.9031 17 16.4777 17H3.52232ZM9.1579 12.6V11H10.8421V12.6H9.1579ZM2 11.2V7.2462C2 6.84207 2.14737 6.5 2.44211 6.22C2.73684 5.94 3.09691 5.8 3.52232 5.8H7.05263V4.4462C7.05263 4.04207 7.2 3.7 7.49474 3.42C7.78947 3.14 8.14954 3 8.57495 3H11.4251C11.8505 3 12.2105 3.14 12.5053 3.42C12.8 3.7 12.9474 4.04207 12.9474 4.4462V5.8H16.4777C16.9031 5.8 17.2632 5.94 17.5579 6.22C17.8526 6.5 18 6.84207 18 7.2462V11.2H12.1053V9.8H7.89474V11.2H2ZM8.31579 5.8H11.6842V4.4462C11.6842 4.3846 11.6572 4.3282 11.6032 4.277C11.5493 4.22567 11.4899 4.2 11.4251 4.2H8.57495C8.51011 4.2 8.45074 4.22567 8.39684 4.277C8.34281 4.3282 8.31579 4.3846 8.31579 4.4462V5.8Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.7a6aa9cf13eafdfb05569b3c6c02fb44.svg";
export { ForwardRef as ReactComponent };